import { getInstance } from './instance';

const instance = getInstance();

export const getStep = (offerCode, session) => {
  const url = `/onboard/step?offerCode=${offerCode}&sessionId=${session}`;

  return instance.get(url);
};

export const getSummary = ({ offerCode, sessionId }) => {
  const url = `/onboard/summary?offerCode=${offerCode}&sessionId=${sessionId}`;

  return instance.get(url);
};

export const fetchSession = (offerCode, sessionId) => {
  const url = `/onboard/session?offerCode=${offerCode}&sessionId=${sessionId}`;

  return instance.get(url);
};

export const postFirstLogin = ({ email, password }) => {
  const url = 'onboard/login';

  const params = {
    email,
    password,
  };

  const headers = {
    'Content-Type': 'application/json',
  };

  return instance.post(url, params, { headers });
};

export const updateUpsellSession = (parameters) => {
  const url = 'upsell/update-params';

  return instance.post(url, parameters);
};
